export default __webpack_public_path__ + "static/media/id-card.6c178106.svg";